export default __webpack_public_path__ + "static/media/ResinPrintingImg.34bab497.jpg";